export default {
  AVAILABLES_CONTENTS: {
    Masterclass: 'theme',
    LessonStep: 'lessonStep',
    Lesson: 'lesson'
  },
  STATE: {
    Loading: 'loading',
    Ready: 'ready',
    NoVideo: 'no-video',
    NoPodcast: 'no-podcast',
    NoOffline: 'no-offline',
    Downloading: 'downloading',
    Downloaded: 'downloaded',
    PartialDownload: 'partial',
    Error: 'error'
  }
}
